import React from 'react';
import { PracticeAddress } from './PracticeAddress';
import { CustomPracticeAddress } from './CustomPracticeAddress';
import { Typography } from 'src/latest/src/components';
import { QuestionsUniqueKeys } from 'src/containers/QuestionnaireParent/QuestionnaireEnum';

interface Choice {
  value: string;
  selected?: boolean;
  [key: string]: any; // Allow other properties
}

interface Question {
  unique_key: string;
  choices: Choice[];
}

interface Section {
  questions: Question[];
}

interface Props {
  section: Section;
  title?: string;
}

export const TherapistPracticeAddress: React.FC<Props> = ({
  section,
  title,
}) => {
  const isCustomAddress = section?.questions?.some(
    q => q.unique_key === QuestionsUniqueKeys.inPersonOfficeAddressQuestion,
  );

  return (
    <>
      {title && (
        <Typography
          variant="size-14"
          weight="bold"
          color="color-28"
          className="therapist-profile__title mb-3"
        >
          {title}
        </Typography>
      )}
      {section && isCustomAddress && (
        <CustomPracticeAddress questions={section.questions} />
      )}
      {section &&
        !isCustomAddress &&
        section.questions?.map((question, index) => (
          <>
            {question && (
              <PracticeAddress
                key={index}
                choices={question?.choices}
                isPracticeAddress={false}
              />
            )}
          </>
        ))}
      {!isCustomAddress &&
        section?.questions[0]?.choices?.filter((choice: any) => choice.selected)
          .length === 0 && (
          <Typography variant="size-16" weight="regular" color="color-2">
            N/A
          </Typography>
        )}
    </>
  );
};
